import React from "react";

export function ChevronDown( props: React.SVGProps<SVGSVGElement> ) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.35883 4.46967C2.06594 4.76256 2.06594 5.23732 2.35883 5.53022L5.47016 8.64154C5.76307 8.93422 6.23788 8.93437 6.53071 8.64154L9.64203 5.53022C9.93464 5.23738 9.93464 4.76251 9.64203 4.46967C9.34914 4.17678 8.8734 4.17678 8.58051 4.46967L5.99946 7.04975L3.41938 4.46967C3.12648 4.17678 2.65172 4.17678 2.35883 4.46967Z"
                fill="var(--ui-content-t1)"
            />
        </svg>
    );
}

export function ChevronUp( props: React.SVGProps<SVGSVGElement> ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            style={{ transform: "rotate(180deg)" }}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.35883 4.46967C2.06594 4.76256 2.06594 5.23732 2.35883 5.53022L5.47016 8.64154C5.76307 8.93422 6.23788 8.93437 6.53071 8.64154L9.64203 5.53022C9.93464 5.23738 9.93464 4.76251 9.64203 4.46967C9.34914 4.17678 8.8734 4.17678 8.58051 4.46967L5.99946 7.04975L3.41938 4.46967C3.12648 4.17678 2.65172 4.17678 2.35883 4.46967Z"
                fill="var(--ui-content-t1)"
            />
        </svg>
    );
}
